const defaultConfigAggregator = (node) => {
    return {
        html: node.innerHTML,
        enabled: node.getAttribute('data-enabled') !== 'false',
        widgetConfiguration: {
            ...Array.from(node.attributes)
                .filter((attr) => attr.name.startsWith('data-w')) // Filter attributes that start with 'data-'
                .reduce((acc, attr) => {
                    const attrNameWithoutData = attr.name.slice(7) // Remove 'data-w-' from the name
                    acc[attrNameWithoutData] = attr.value
                    return acc
                }, {})
        }
    }
}
export default defaultConfigAggregator
